import { isEmpty } from './isEmpty';

export function getNonEmpty(func, ...values) {
  return values.find((v) => func(v) && !isEmpty(v));
}
